var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.03223 1.5H18C18.8284 1.5 19.5 2.17158 19.5 3V17.9677C19.5 18.7962 18.8284 19.4677 18 19.4677H3.03223C2.2038 19.4677 1.53223 18.7962 1.53223 17.9677V3C1.53223 2.17157 2.2038 1.5 3.03223 1.5ZM0.0322266 3C0.0322266 1.34315 1.37537 0 3.03223 0H18C19.6568 0 21 1.34315 21 3V17.9677C21 19.6246 19.6568 20.9677 18 20.9677H3.03223C1.37538 20.9677 0.0322266 19.6246 0.0322266 17.9677V3ZM6.79621 15.5646C6.48448 15.8373 6.45289 16.3112 6.72565 16.6229C6.99842 16.9346 7.47224 16.9662 7.78396 16.6934L14.2356 11.0483C14.3983 10.9059 14.4917 10.7001 14.4917 10.4839C14.4917 10.2676 14.3983 10.0618 14.2356 9.91942L7.78397 4.27426C7.47224 4.0015 6.99842 4.03309 6.72565 4.34482C6.45289 4.65654 6.48448 5.13037 6.79621 5.40313L12.6028 10.4839L6.79621 15.5646Z",
    fill: "#0078E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageArrowRight);
export default __webpack_public_path__ + "static/media/PageArrowRight.6c1bfd0c0ee5b32bfc1c17862a1364bf.svg";
export { ForwardRef as ReactComponent };